import { deleteData, getData } from "../axiosConfig"

export const getUsers = async () => {
    return await getData('/admin/users')
}

export const deleteUsers = async (id) => {
    return await deleteData(`/admin/users/${id}`)
}


export const getTransactions = async (id) => {
    return await getData(`/admin/users/transactions/${id}`)
}

export const getUserAccountDetail = async (id) => {
    return await getData(`/admin/users/account-detail/${id}`)
}

export const getUserWithdrawableTransactions = async (id) => {
    return await getData(`/admin/users/withdrawl-request/${id}`)
}

export const getPayoutsRequest = async () => {
    return await getData(`admin/payouts-request`)
}

export const updatePayoutsRequest = async (id) => {
    return await getData(`/admin/payouts-request/approve/${id}`)
}

export const getNewsletter = async () => {
    return await getData(`admin/newsletter-emails`)
}

